import { render, staticRenderFns } from "./NursingCareGroupList.vue?vue&type=template&id=37519508"
import script from "./NursingCareGroupList.vue?vue&type=script&lang=js"
export * from "./NursingCareGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports